// stores/counter.js
import moment from "moment";
import {
    defineStore
} from "pinia";

export const useGlobalActionsStore = defineStore("GlobalActions", {
    state: () => {
        return {
            globalConfig: {
                stretchTimeGlobal: []
            },
            snackBar: {
                open: false,
                message: 'Este es mi mensaje ❌',
                closeButton: true
            },
            loader: {
                open: false,
                message: null
            },
            alertConfirm:{
                open:false,
                title: null,
                message: null,
                buttonCancelText: null,
                buttonConfirmText: null,
                onCancel: () => {},
                onConfirm: () => {}
            }
        };
    },

    // could also be defined as
    // state: () => ({ count: 0 })
    actions: {

    },
});
